import Vue from "vue";
import Course from "@/models/Course";
import LiveCourse from "@/models/LiveCourse";
import axios from "axios";

export default class LiveCourseApi {

    constructor(api) {
        this.api = api;
    }

    get(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.get("live/" + id).then((response) => {
                callback(new LiveCourse(response.data));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    getAll(callback, error) {
        this.api.getRaw((axios) => {
            axios.get("live").then((response) => {
                console.log(response)
                callback(response.data.map((date) => new LiveCourse(date)));
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    update(data, callback, error) {
        this.api.getRaw((axios) => {
            axios.put("live/" + data.id, data).then((response) => {
                callback(new LiveCourse(response.data));
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    create(data, callback, error) {
        this.api.getRaw((axios) => {
            axios.post("live", data).then((response) => {
                callback(new LiveCourse(response.data));
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    approveShippers(courseId, userId, callback, error) {
        this.api.getRaw((axios) => {
            axios.post(`live/${courseId}/${userId}/shippers/accept`).then((response) => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    denyShippers(courseId, userId, callback, error) {
        this.api.getRaw((axios) => {
            axios.post(`live/${courseId}/${userId}/shippers/deny`).then((response) => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

    downloadShippers(courseId, userId, name) {
        this.api.getRaw((axios) => {
            axios.get(`live/${courseId}/${userId}/shippers/download`, {responseType: 'blob'})
                .then(response => {
                    const blob = new Blob([response.data], {type: 'application/pdf'})
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = name;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch((err) => {
                console.error(err);
            })
        })
    }

    downloadDeclaredGoods(courseId, userId, name) {
        this.api.getRaw((axios) => {
            axios.get(`live/${courseId}/${userId}/declaredgoods/download`, {responseType: 'blob'})
                .then(response => {
                    const blob = new Blob([response.data], {type: 'application/pdf'})
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = name;
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch((err) => {
                console.error(err);
            })
        })
    }

    upload(file, course, callback, error) {
        let formData = new FormData();
        formData.append("file", file);
        this.api.getRaw((axios) => {
            axios.post(`live/${course}/csv/upload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }, (newProgress) => {
                console.log(newProgress)
            }).then(() => {
                callback();
            }).catch((err) => {
                Vue.$log.error("Error", err);
                if (error) error(err)
            });
        });
    }

    delete(id, callback, error) {
        this.api.getRaw((axios) => {
            axios.delete("live/" + id).then(() => {
                callback();
            }).catch((err) => {
                if (error) error(err)
            });
        });
    }

}
